import { render, staticRenderFns } from "./categorySelect.vue?vue&type=template&id=36b3e869&scoped=true"
import script from "./categorySelect.vue?vue&type=script&lang=js"
export * from "./categorySelect.vue?vue&type=script&lang=js"
import style0 from "./categorySelect.vue?vue&type=style&index=0&id=36b3e869&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3e869",
  null
  
)

export default component.exports